module.exports = __webpack_public_path__ + "static/media/message-notification.8a8b917c.mp3";